import { render, staticRenderFns } from "./themeColor.vue?vue&type=template&id=b7a6bb24&lang=pug"
import script from "./themeColor.vue?vue&type=script&lang=js"
export * from "./themeColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports